import React from 'react';
import { Job, JobStatus } from '../../data/types';
import { PricingMode } from '../../theme/timeAndMaterialsTokens';

const STATUS_PILL: Record<JobStatus, { label: string; cls: string }> = {
  Scheduled: { label: 'Scheduled', cls: 'blue' },
  'In Progress': { label: 'In progress', cls: 'green' },
  Completed: { label: 'Completed', cls: 'grey' },
  'On Hold': { label: 'On hold', cls: 'grey' },
  Cancelled: { label: 'Cancelled', cls: 'grey' },
};

interface JobOption {
  ref: string;
  label: string;
}

interface Props {
  jobRef: string;
  job?: Job;
  jobOptions: JobOption[];
  pricingMode: PricingMode;
  onPricingMode: (mode: PricingMode) => void;
  onJobRef: (ref: string) => void;
  onOpenSettings: () => void;
  billableCount: number;
}

export const JobEditChrome: React.FC<Props> = ({
  jobRef,
  job,
  jobOptions,
  pricingMode,
  onPricingMode,
  onJobRef,
  onOpenSettings,
  billableCount,
}) => {
  const status = job?.status ?? 'Scheduled';
  const pill = STATUS_PILL[status];
  const displayNum = job?.number ?? (jobRef.replace(/^WO-?/i, '') || jobRef);

  return (
    <>
      <div className="tm-hdr">
        <div className="tm-hdr-top">
          <div className="tm-title-wrap">
            <div className="tm-title">
              <span className="chev">›</span>
              Edit job #{displayNum}
              <span className="tm-wip-label">WIP job</span>
            </div>
            <select
              className="tm-pricing-top"
              value={pricingMode}
              onChange={e => onPricingMode(e.target.value as PricingMode)}
              title="Job pricing"
            >
              <option>Do &amp; Charge</option>
              <option>Fixed price</option>
            </select>
            {jobOptions.length > 1 && (
              <select
                className="tm-pricing-top"
                value={jobRef}
                onChange={e => onJobRef(e.target.value)}
                title="Switch job"
                style={{ minWidth: 220 }}
              >
                {jobOptions.map(o => (
                  <option key={o.ref} value={o.ref}>{o.label}</option>
                ))}
              </select>
            )}
          </div>
          <div className="tm-hdr-right">
            <span className="tm-primary">Primary job: <b>{jobRef}</b></span>
            <span className={`tm-pill ${pill.cls}`}>{pill.label}</span>
            {status === 'Scheduled' && <span className="tm-pill green">Start job</span>}
            <button type="button" className="tm-cog" onClick={onOpenSettings} title="Inventory settings">⚙</button>
          </div>
        </div>
        <div className="tm-cust">
          <div>
            <div className="lbl">Site customer</div>
            <div className="val">{job?.customer ?? '—'}</div>
          </div>
          <div>
            <div className="lbl">Site customer address</div>
            <div className="val">{job?.address ?? '—'}</div>
            {job?.phone && <div className="phone">📱 {job.phone}</div>}
          </div>
          <div>
            <div className="lbl">Account customer</div>
            <div className="val">{job?.customer ?? '—'}</div>
          </div>
          <div>
            <div className="lbl">Project</div>
            <div className="val">{job?.title ?? '—'}</div>
          </div>
        </div>
      </div>

      <div className="tm-tabs">
        <div className="tm-tab on">Job</div>
        <div className="tm-tab">Assets</div>
        <div className="tm-tab">Sales</div>
        <div className="tm-tab">Reports</div>
        <div className="tm-tab">Safety</div>
      </div>
      <div className="tm-tabs sub">
        <div className="tm-tab">Details</div>
        <div className="tm-tab on">
          Time and materials <span className="cnt">{billableCount}</span>
        </div>
        <div className="tm-tab">Skills</div>
        <div className="tm-tab">Todo</div>
        <div className="tm-tab">Visits</div>
        <div className="tm-tab">Profit report</div>
        <div className="tm-tab">History</div>
      </div>
    </>
  );
};
